import { passwordStrength } from 'check-password-strength'
export default function () {
    const labels = ['Bardzo słabe', 'Słabe', 'Średnie', 'Silne'];
    const widths = ['20%', '45%', '70%', '100%'];

    document.querySelectorAll('[data-password-strength]').forEach(input => {

        input.addEventListener('input', () => {
            const res = passwordStrength(input.value);
            const strengthLabel = input.nextElementSibling;
            strengthLabel.textContent = labels[res.id];
         
            const bar = document.getElementById('bar');
            bar.className = `bar s${res.id}`;
            bar.style.width = widths[res.id];
        });

    });
    

}